var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3731 6.92994C20.5729 0.924734 13.4347 -1.67328 7.42973 1.12688C1.42475 3.92704 -1.1733 11.0649 1.6269 17.0701C4.4271 23.0753 11.5653 25.6733 17.5703 22.8731C23.5752 20.073 26.1733 12.9351 23.3731 6.92994ZM13.8828 14.9654C12.245 15.7289 11.5366 17.6759 12.3002 19.3136C13.0638 20.9513 15.0106 21.6597 16.6483 20.8962C18.2861 20.1321 18.9945 18.1857 18.2309 16.548C17.4673 14.9103 15.5205 14.2019 13.8828 14.9654ZM12.039 11.0115C11.4932 11.2658 11.2569 11.915 11.5115 12.4611C11.7661 13.0066 12.415 13.2428 12.961 12.9885C13.5068 12.7342 13.7431 12.085 13.4885 11.5389C13.2339 10.9934 12.585 10.7572 12.039 11.0115ZM17.048 6.26901C15.4102 7.03306 14.7018 8.97953 15.4654 10.6172C16.2291 12.2549 18.1758 12.9633 19.8135 12.1998C21.4514 11.4363 22.1598 9.48929 21.3961 7.85161C20.6325 6.21393 18.6857 5.50554 17.048 6.26901ZM5.18647 11.8002C3.54863 12.5637 2.84023 14.5107 3.60385 16.1484C4.36748 17.7861 6.31425 18.4945 7.95195 17.731C9.58979 16.9669 10.2982 15.0205 9.53457 13.3828C8.77095 11.7451 6.82417 11.0367 5.18647 11.8002ZM8.35171 3.10381C6.71386 3.86786 6.00547 5.81433 6.76909 7.452C7.53271 9.08968 9.47949 9.79807 11.1172 9.0346C12.755 8.27114 13.4634 6.32409 12.6998 4.68641C11.9362 3.04873 9.9894 2.34034 8.35171 3.10381Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/union.d389f0df514ac630ddf60cf8fb423914.svg";
export { ForwardRef as ReactComponent };